import React, { useCallback, useImperativeHandle, useRef } from "react";

import { Dimmer, Icon, Loader } from "semantic-ui-react";

import TabFramework from "react-lib/frameworks/Tab";

// Controller
import DashboardController from "react-lib/apps/IsHealth/Dashboard/DashboardController";

import CoreManager from "react-lib/apis/manager/CoreManager";
import PRXManager from "react-lib/apis/manager/PRXManager";

// Components
import ManagePermissions from "./ManagePermissions";
import SettingOAAccount from "./SettingOAAccount"; // Import the separated component

interface SettingsProps {
  controller: DashboardController & {
    coreManager: CoreManager;
    prxManager: PRXManager;
    getOAInviteLink: (params: { apiToken: string; divisionId: number }) => Promise<any>;
  };
  apiToken: string;
  division: number;
  isLoadingSettings: boolean;
  onGetDivision?: () => any;
}

// Main Settings Component
const Settings = React.forwardRef<any, SettingsProps>((props, ref) => {
  // Ref
  const managePermissionsRef = useRef<any>();

  useImperativeHandle(ref, () => ({
    getMemberList: () => managePermissionsRef.current?.getMemberList(),
    getPendingList: () => managePermissionsRef.current?.getPendingList(),
    getUserRole: () => managePermissionsRef.current?.getUserRole(),
  }));

  const handleOAUpdated = useCallback(() => {
    props.onGetDivision?.();
  }, []);

  return (
    <div className="setting-oa" style={{ width: "100%" }}>
      <Dimmer active={props.isLoadingSettings} inverted>
        <Loader inverted>Loading</Loader>
      </Dimmer>

      <TabFramework
        header={["ตั้งค่าบัญชี OA", "การจัดการสิทธิ"]}
        tabWidth="150px"
        data={[
          {
            key: "ตั้งค่าบัญชี OA",
            name: (
              <div style={{ color: "#5dbcd2", display: "flex", justifyContent: "center" }}>
                <Icon name="user" /> ตั้งค่าบัญชี OA
              </div>
            ),
            render: () => (
              <SettingOAAccount
                controller={props.controller}
                apiToken={props.apiToken}
                division={props.division}
                onUpdated={handleOAUpdated}
              />
            ),
          },
          {
            key: "การจัดการสิทธิ",
            name: (
              <div style={{ color: "#5dbcd2", display: "flex", justifyContent: "center" }}>
                <Icon name="group" /> การจัดการสิทธิ
              </div>
            ),
            render: () => (
              <ManagePermissions
                ref={managePermissionsRef}
                controller={props.controller}
                apiToken={props.apiToken}
                division={props.division}
                readOnly={false}
              />
            ),
          },
        ]}
      />
    </div>
  );
});

Settings.displayName = "Settings";

export default React.memo(Settings);
